<template>
    <button
        @click="$emit('close-chat')"
        class="fixed top-[30px] [@media(min-width:768px)]:top-[20px] right-1/10 [@media(min-width:768px)]:right-1/4 
        text-xl bg-transparent border-transparent font-bold z-50"
        aria-label="Close"
    >
        <img
            src="@/assets/x_marker.png"
            alt="X_Market"
        />
    </button>
</template>